import { Controller, useFormContext } from 'react-hook-form';
import { InputBox } from '../../../../../../components/InfoInput';
import { PMC_SOURCE_OPTIONS } from '../constants';
import { PmcSource, pmcSourceSchema, SetupFarmaFormValues } from '../schema';
import styles from '../SetupFarma.module.scss';

type SetupPMCSourceSelectorProps = {
  disabled: boolean;
};

export const SetupPMCSourceSelector = ({ disabled }: SetupPMCSourceSelectorProps) => {
  const { control } = useFormContext<SetupFarmaFormValues>();

  return (
    <Controller
      control={control}
      name="pmcConfig"
      render={({ field }) => (
        <InputBox.RadioGroup
          className={styles.pmcSourceSelector}
          name={field.name}
          value={field.value}
          onChange={value => field.onChange(value as PmcSource)}
        >
          {pmcSourceSchema.options.map(source => (
            <InputBox.Radio key={source} className={styles.pmcSourceOption} value={source} disabled={disabled}>
              <span>{PMC_SOURCE_OPTIONS[source].label}</span>
              <InputBox.FormDescription>{PMC_SOURCE_OPTIONS[source].description}</InputBox.FormDescription>
            </InputBox.Radio>
          ))}
        </InputBox.RadioGroup>
      )}
    />
  );
};
